import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#normalizeOurStoryContent();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #normalizeOurStoryContent() {
    if (!this.closest('.main-page--our-story')) return;

    Array.from(this.children).forEach((element) => {
      const text = (element.textContent || '').replace(/\u00a0/g, ' ').trim();
      const images = Array.from(element.querySelectorAll('img'));
      const validImages = images.filter((image) => {
        const src = image.getAttribute('src') || '';
        const alt = (image.getAttribute('alt') || '').trim().toLowerCase();
        return Boolean(src.trim()) && alt !== 'our family of 4';
      });

      const isFamilyLine = text.toLowerCase() === 'our family of 4';
      const hasOnlyBrokenImages = images.length > 0 && validImages.length === 0 && text === '';
      const isEffectivelyEmpty = text === '' && validImages.length === 0 && !element.querySelector('table');

      if (isFamilyLine || hasOnlyBrokenImages || isEffectivelyEmpty) {
        element.remove();
      }
    });
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
